<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ng-container *ngFor="let p of consulta?.lista; let i = index">
      <h2 class="subtitle">{{i+1}}º PROPRIETÁRIO</h2>
      <ul class="card-list-striped">
        <li><span class="text-secondary">Nome do proprietário
          </span><span>{{p?.nomeProprietario || 'NÃO INFORMADO'}}</span>
        </li>
        <li><span class="text-secondary">Ano exercício </span><span>{{p?.anoExercicio || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">CGC CPF </span><span>{{p?.cgcCpf || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Renavam </span><span>{{p?.renavam || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Placa </span><span>{{p?.placa || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Chassi </span><span>{{p?.chassi || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">UF </span><span>{{p?.ufDut || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Saldo </span><span>{{p?.saldo || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Id pag </span><span>{{p?.idPagDut || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Número Dut </span><span>{{p?.numeroDut || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Número de bancos </span><span>{{p?.numeroBanco || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Data de processamento
          </span><span>{{p?.dataProcessamento || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Data de emissão de guia
          </span><span>{{p?.dataEmissaoGuia | date: 'dd/MM/yyyy' || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Nome agente financeiro
          </span><span>{{p?.nomeAgenteFinanceiro || 'NÃO INFORMADO'}}</span></li>
      </ul>
    </ng-container>

  </ng-container>

</app-card-consulta>
